<script setup>
import {useRouter} from "vue-router";
import {useStore} from "vuex";
import { ref } from "vue";
import ScheduleDataTable from "@/components/architect/ScheduleDataTable.vue";

const router = useRouter();
const store = useStore();

const scheduleTableRef = ref(null);

const goToDashboardView = async () => {
  const carbonImpactData = {
    materialtotals: {
      area : Number(scheduleTableRef.value?.totalArea ?? 0),
      volume : Number(scheduleTableRef.value?.totalVolume ?? 0),
      mass : Number(scheduleTableRef.value?.totalMass ?? 0),
      carbonFootprint : Number(scheduleTableRef.value?.totalFootprint ?? 0)
    }
  };
  // TODOEB: We probably want to save this data at the panel count estimator level instead of the carbon impact estimator level, since the carbon impact estimator is just a view of the data calculated at the panel count estimator level
  await store.dispatch("saveCarbonImpactData", carbonImpactData);
  router.push({name: 'ArchitectDashboard'});
};

</script>

<template>
  <v-card class="default-card" elevation="3">
    <v-card-text>
      <ScheduleDataTable ref="scheduleTableRef"/>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="secondary" variant="flat" @click="goToDashboardView">
        {{ $t('buttons.backToDashboard') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<style scoped></style>
